import React from 'react';
import { size, map } from 'lodash-es';
import i18next from 'i18next';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { faGlobeEurope } from '@fortawesome/pro-regular-svg-icons';

import { SimpleDropDown, SimpleDropDownElement } from 'components/simple-dropdown';
import { displaySettingsSelector } from 'common/selectors';
import { getI18nLng } from 'utils/i18n';

export const LangSwitcher = connect(
  (state) => ({
    displaySettings: displaySettingsSelector(state),
  }),
  false
)(({ displaySettings: { languages } }) => {
  const { t } = useTranslation();
  if (size(languages) === 1) {
    return false;
  }

  const i18nextLanguage = getI18nLng();

  return (
    <SimpleDropDown
      title={i18nextLanguage.toUpperCase()}
      icon={faGlobeEurope}
      className="ct-control-bar__element"
      left={true}
      data-e2e="ct-lng-switcher"
      aria-label={t('app-language-menu')}
    >
      {map(languages, (language) => (
        <SimpleDropDownElement
          key={language}
          onClick={() => {
            i18next.changeLanguage(language);
            document.location.reload();
          }}
          bold={language === i18nextLanguage}
          aria-label={t(language)}
          role="menuitem"
          aria-current={language === i18nextLanguage ? 'true' : undefined}
        >
          {t(language)}
        </SimpleDropDownElement>
      ))}
    </SimpleDropDown>
  );
});
